<div class="">
  <legend>RADIUS Authentication</legend>
  <arm-form (submitForm)="submit()" [disableSubmit]="!canSubmit || disableServerTestAndSubmit()">
    <div class="raidus-authentication-settings">
      <div class="form-table-column-server-attribute">

        <arm-form-title>RADIUS AUTHENTICATION SERVER</arm-form-title>
        <div class="settings-section">
          <div class="radius-attributes">
            <div class="main-attribute">
              <mat-slide-toggle color="primary"
                                [checked]="radiusAuthentication.isEnabled"
                                (change)="radiusAuthentication.isEnabled = $event.checked">
                Enable RADIUS Authentication
              </mat-slide-toggle>

              <mat-form-field class="customWidth">
                <mat-label>Server IP</mat-label>
                <input [(ngModel)]="radiusAuthentication.host" matInput name="host"
                       [required]="radiusAuthentication.isEnabled">
              </mat-form-field>

              <mat-form-field class="port customWidth">
                <mat-label>Server Port</mat-label>
                <input [(ngModel)]="radiusAuthentication.port" matInput min="1"
                       max="65535" name="port" type="number" [required]="radiusAuthentication.isEnabled">
              </mat-form-field>

              <mat-form-field class="customWidth">
                <mat-label>Server secret</mat-label>
                <input type="password" [(ngModel)]="radiusAuthentication.sharedSecret" matInput name="secret"
                       minlength="1" maxLength="100">
              </mat-form-field>

              <mat-form-field class="customWidth">
                <mat-label>RADIUS retransmit timeout (msec)</mat-label>
                <input [(ngModel)]="radiusAuthentication.timeout" matInput min="1" name="timeout" type="number">
              </mat-form-field>

              <mat-form-field class="customWidth">
                <mat-label>RADIUS auth number of retries</mat-label>
                <input [(ngModel)]="radiusAuthentication.retryCount" matInput min="1" name="retryCount" type="number">
              </mat-form-field>

              <ac-input-container label="Default Security Policy" class="customWidth">
                <ac-select [(acModel)]="radiusAuthentication.defaultRole"
                           [items]="securityLevelsOptions"
                           [bindValue]="'id'"
                           [bindLabel]="'name'">
                </ac-select>
              </ac-input-container>
            </div>

            <div class="advanced-attributes">
              <ac-line-separator title="Advanced"></ac-line-separator>
              <mat-form-field class="customWidth">
                <mat-label>NAS IP Address</mat-label>
                <input [(ngModel)]="radiusAuthentication.nasIpAddress" matInput name="nasIpAddress">
              </mat-form-field>

              <mat-form-field class="customWidth">
                <mat-label>NAS Port</mat-label>
                <input type="number" [(ngModel)]="radiusAuthentication.nasPort" matInput name="nasPort" min="1"
                       max="65535">
              </mat-form-field>

              <mat-form-field class="customWidth">
                <mat-label>NAS Identifier</mat-label>
                <input [(ngModel)]="radiusAuthentication.nasIdentifier" matInput name="nasIdentifier" >
              </mat-form-field>

              <mat-form-field class="customWidth">
                <mat-label>Additional attribute name</mat-label>
                <input [(ngModel)]="radiusAuthentication.additionalAttributeKey" matInput name="key">
              </mat-form-field>


              <mat-form-field class="customWidth">
                <mat-label>Additional attribute value</mat-label>
                <input [(ngModel)]="radiusAuthentication.additionalAttributeValue" matInput name="value" >
              </mat-form-field>
            </div>
          </div>


          <div class="radius-server-test-connectivity-result-wrapper"
               [class]="{'green': testResultServer === 'RADIUS server connection test successful'}">
            <mat-label class="radius-server-test-connectivity-result">{{testResultServer}}</mat-label>
          </div>

          <div class="radius-server-test-connectivity-button-container">
            <ac-button (click)="testServerConnectivity()" buttonId="test-server"
                       [ngDisabled]="!radiusAuthentication.host || !radiusAuthentication.port || disableServerTestAndSubmit() ">Test
            </ac-button>
          </div>
        </div>

      </div>
      <div class="form-table-column">
        <arm-form-title>Test Connectivity</arm-form-title>
        <div class="settings-section">
          <mat-form-field class="customWidth">
            <mat-label>Name</mat-label>
            <input [(ngModel)]="radiusAuthentication.testConnectivity.name" matInput name="test-connectivity-name">
          </mat-form-field>

          <mat-form-field class="customWidth">
            <mat-label>Password</mat-label>
            <input type="password" [(ngModel)]="radiusAuthentication.testConnectivity.password" matInput
                   name="test-connectivity-password">
          </mat-form-field>

          <div class="radius-test-connectivity-result-wrapper"
               [class]="{'green': testResult === 'RADIUS server connection test successful'}">
            <mat-label class="radius-test-connectivity-result">{{testResult}}</mat-label>
          </div>

          <div class="radius-test-connectivity-button-container">
            <ac-button
              [ngDisabled]="!radiusAuthentication.testConnectivity.password || !radiusAuthentication.testConnectivity.name"
              (click)="testConnectivity()" buttonId="test-user">Test
            </ac-button>
          </div>
        </div>
        <arm-form-title>AUTHENTICATION MODE</arm-form-title>
        <div class="settings-section">
          <ac-input-container label="Authentication Order" class="customWidth">
            <ac-select [acModel]="radiusAuthentication.isLocalFirst"
                       [searchable]="false"
                       (acModelChange)="radiusAuthentication.isLocalFirst = $event"
                       [items]="authenticationOrderList"
                       bindLabel="description"
                       bindValue="bool">
            </ac-select>
          </ac-input-container>
        </div>

      </div>
    </div>
  </arm-form>
</div>
